import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ConsumableLifetimeCycle = React.lazy(() => import('.'));

export const consumableLifetimeCycleRoutes = [
  new Route({
    path: 'consumable-lifetime-cycle',
    element: ConsumableLifetimeCycle,
    children: [],
  }),
];
